import Divider from "@mui/material/Divider";
import React from "react";

const DividerComponent = ({ orientation = "horizontal", ...props }) => {
  return <Divider orientation={orientation} {...props} />;
};

export default DividerComponent;
